import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AccountNameService, AgencyIdService} from "../../account.service";
import {ApiService} from "../../api_service/api.service";
import * as _ from "lodash";
import {IntegrationProviderService} from "../integration-provider.service";
import {environment} from '../../../environments/environment';


export interface  ClickFunnelPostInterfaceData {
  serviceName: string
}



@Component({
  selector: 'app-integrations-clickfunnels',
  templateUrl: './integrations-clickfunnels.component.html',
  styleUrls: ['./integrations-clickfunnels.component.css']
})
export class IntegrationsClickfunnelsComponent implements OnInit {

  helps = []

  agency_id:string;
  account_id:string;
  is_connected = false;
  is_code = false;
  data = {};
  is_webhook_id = false;
  is_loading = false;
  DOMAIN = environment['DOMAIN'];

  constructor(public router: Router,
              public route: ActivatedRoute,
              public dialog: MatDialog,
              private currentrouteService: CurrentRouteService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private _apiService: ApiService,
              private _integrationProviderService: IntegrationProviderService,
  ) { }

  ngOnInit(): void {

    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
      this.accountidService.announceAccountId(this.account_id);
      this.load_data();
    });
  } // end of ngOnInit


  load_data(){

    this.is_loading = true;

    let endpoint = `webhooks/account/${this.account_id}`;

    let fu = this._integrationProviderService.get(endpoint).subscribe(x => {
      if (_.isEmpty(x['body'])){
        //this.is_data = true
      } else {
        for (const [cn, v] of Object.entries(x['body'])) {
          if (v['serviceName'] == 'click_funnels'){
            this.data = v;
          }
        }
      } //end if-else

      if ('webhook_id' in this.data){
        this.is_webhook_id = true;
        this.is_code = true;
      }
      this.is_loading = false;
    },error => {
      console.log('ERROR ',error)
      this.is_loading = false;
    }); //end _integrationProviderService

  } //end load_data



  goBack() {
    window.history.back();
  }

  onAdd(){

    let endpoint = `webhooks/account/${this.account_id}`
    let data:ClickFunnelPostInterfaceData = {serviceName: 'click_funnels'}
    this._integrationProviderService.post_clickfunnels(endpoint, data).subscribe(x => {
      this.load_data()
    }); //end post

    this.is_code = true;
  }

}
